import { Link } from "react-router-dom";
import { getSettingsData } from "../context/AuthContext";

const Footer = () => {
  const { company_name } = getSettingsData();
  return (
    <footer className="content-footer footer bg-footer-theme">
      <div className="container-xxl">
        <div className="footer-container d-flex align-items-center justify-content-between py-4 flex-md-row flex-column">
          <div className="text-body">
            © 2024{" "}
            <Link className="footer-link" to="#">
              {company_name}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
